import { useContext } from "react";
import { ThemeContext } from "@emotion/react";
import Paper from '@mui/material/Paper';
import { GroupingTable } from "../../../components/Table/grouping_table";

export const TablaDefectivos = ({ sample }) => {

  const theme = useContext(ThemeContext);
  const sort = {}

  const columns = [
    {
      accessorKey: 'def_area',
      header: 'Área',
    },
    {
      accessorKey: 'def_codigo',
      header: 'Código',
    },
    {
      accessorKey: 'def_defecto',
      header: 'Defecto',
    },
  ]
  const rows = sample;


  return (
    <Paper style={{ height: '100%', width: '100%' }} sx={{ boxShadow: 'none' }}>
      <GroupingTable key='table_partes' columnas={columns} data={rows} sort={sort} />
    </Paper>
  )
}